import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  background-color: #0066ff;
  border: 2px solid #fff;
  border-radius: 100%;
  user-select: none;
  transform: translate(-50%, -50%);
  &:hover {
    z-index: 1;
  }
`;

const GooglePlaceMarker = ({ text }) => {
  return (
    <div>
      <Wrapper alt={text} data-tip={text} />
      <ReactTooltip type="light" />
    </div>
  );
};

GooglePlaceMarker.propTypes = {
  text: PropTypes.string.isRequired
};

export default GooglePlaceMarker;



// WEBPACK FOOTER //
// ./src/components/GooglePlaceMarker.js